const specials = {
    COLOR: -1,
    SECONDARY_COLOR: -2,
    BRIGHTNESS: -3,
    NEW_BRIGHTNESS: -4,
    BASE400: -5,
    ACCENT400: -6,
    SECONDARY_BASE400: -7,
    SECONDARY_ACCENT400: -8,
};

const colorPalette = {
    0: {
        '000': ['#000000', '#FFFFFF', 0],
        '001': ['#000000', '#FFFFFF', 3],
        '002': ['#000000', '#FFFFFF', 10],
        '003': ['#000000', '#FFFFFF', 25],
        '004': ['#000000', '#FFFFFF', 40],
        '005': ['#000000', '#FFFFFF', 50],
        '006': ['#000000', '#FFFFFF', 60],
        '007': ['#000000', '#FFFFFF', 75],
        '008': ['#000000', '#FFFFFF', 90],
        '009': ['#000000', '#FFFFFF', 100],
        100: [specials.COLOR, '#FFFFFF', 0],
        101: [specials.COLOR, '#FFFFFF', 10],
        102: [specials.COLOR, '#FFFFFF', 20],
        103: [specials.COLOR, '#FFFFFF', 30],
        104: [specials.COLOR, '#FFFFFF', 40],
        105: [specials.COLOR, '#FFFFFF', 50],
        106: [specials.COLOR, '#FFFFFF', 60],
        107: [specials.COLOR, '#FFFFFF', 70],
        108: [specials.COLOR, '#FFFFFF', 80],
        109: [specials.COLOR, '#FFFFFF', 90],
        200: [specials.COLOR, '#E4E4E4', 0],
        201: [specials.COLOR, '#E4E4E4', 10],
        202: [specials.COLOR, '#E4E4E4', 20],
        203: [specials.COLOR, '#E4E4E4', 30],
        204: [specials.COLOR, '#E4E4E4', 40],
        205: [specials.COLOR, '#E4E4E4', 50],
        206: [specials.COLOR, '#E4E4E4', 60],
        207: [specials.COLOR, '#E4E4E4', 70],
        208: [specials.COLOR, '#E4E4E4', 80],
        209: [specials.COLOR, '#E4E4E4', 90],
        300: [specials.COLOR, '#242424', 0],
        301: [specials.COLOR, '#242424', 10],
        302: [specials.COLOR, '#242424', 20],
        303: [specials.COLOR, '#242424', 30],
        304: [specials.COLOR, '#242424', 40],
        305: [specials.COLOR, '#242424', 50],
        306: [specials.COLOR, '#242424', 60],
        307: [specials.COLOR, '#242424', 70],
        308: [specials.COLOR, '#242424', 80],
        309: [specials.COLOR, '#242424', 90],
        400: [specials.BASE400, '#FFFFFF', 0],
        401: [specials.BASE400, '#FFFFFF', 10],
        402: [specials.BASE400, '#FFFFFF', 20],
        403: [specials.BASE400, '#FFFFFF', 30],
        404: [specials.BASE400, '#FFFFFF', 40],
        405: [specials.BASE400, '#FFFFFF', 50],
        406: [specials.BASE400, '#FFFFFF', 60],
        407: [specials.BASE400, '#FFFFFF', 70],
        408: [specials.BASE400, '#FFFFFF', 80],
        409: [specials.BASE400, '#FFFFFF', 90],
        'secondary-100': [specials.SECONDARY_COLOR, '#FFFFFF', 0],
        'secondary-101': [specials.SECONDARY_COLOR, '#FFFFFF', 10],
        'secondary-102': [specials.SECONDARY_COLOR, '#FFFFFF', 20],
        'secondary-103': [specials.SECONDARY_COLOR, '#FFFFFF', 30],
        'secondary-104': [specials.SECONDARY_COLOR, '#FFFFFF', 40],
        'secondary-105': [specials.SECONDARY_COLOR, '#FFFFFF', 50],
        'secondary-106': [specials.SECONDARY_COLOR, '#FFFFFF', 60],
        'secondary-107': [specials.SECONDARY_COLOR, '#FFFFFF', 70],
        'secondary-108': [specials.SECONDARY_COLOR, '#FFFFFF', 80],
        'secondary-109': [specials.SECONDARY_COLOR, '#FFFFFF', 90],
        'secondary-200': [specials.SECONDARY_COLOR, '#E4E4E4', 0],
        'secondary-201': [specials.SECONDARY_COLOR, '#E4E4E4', 10],
        'secondary-202': [specials.SECONDARY_COLOR, '#E4E4E4', 20],
        'secondary-203': [specials.SECONDARY_COLOR, '#E4E4E4', 30],
        'secondary-204': [specials.SECONDARY_COLOR, '#E4E4E4', 40],
        'secondary-205': [specials.SECONDARY_COLOR, '#E4E4E4', 50],
        'secondary-206': [specials.SECONDARY_COLOR, '#E4E4E4', 60],
        'secondary-207': [specials.SECONDARY_COLOR, '#E4E4E4', 70],
        'secondary-208': [specials.SECONDARY_COLOR, '#E4E4E4', 80],
        'secondary-209': [specials.SECONDARY_COLOR, '#E4E4E4', 90],
        'secondary-300': [specials.SECONDARY_COLOR, '#242424', 0],
        'secondary-301': [specials.SECONDARY_COLOR, '#242424', 10],
        'secondary-302': [specials.SECONDARY_COLOR, '#242424', 20],
        'secondary-303': [specials.SECONDARY_COLOR, '#242424', 30],
        'secondary-304': [specials.SECONDARY_COLOR, '#242424', 40],
        'secondary-305': [specials.SECONDARY_COLOR, '#242424', 50],
        'secondary-306': [specials.SECONDARY_COLOR, '#242424', 60],
        'secondary-307': [specials.SECONDARY_COLOR, '#242424', 70],
        'secondary-308': [specials.SECONDARY_COLOR, '#242424', 80],
        'secondary-309': [specials.SECONDARY_COLOR, '#242424', 90],
        'secondary-400': [specials.SECONDARY_BASE400, '#FFFFFF', 0],
        'secondary-401': [specials.SECONDARY_BASE400, '#FFFFFF', 10],
        'secondary-402': [specials.SECONDARY_BASE400, '#FFFFFF', 20],
        'secondary-403': [specials.SECONDARY_BASE400, '#FFFFFF', 30],
        'secondary-404': [specials.SECONDARY_BASE400, '#FFFFFF', 40],
        'secondary-405': [specials.SECONDARY_BASE400, '#FFFFFF', 50],
        'secondary-406': [specials.SECONDARY_BASE400, '#FFFFFF', 60],
        'secondary-407': [specials.SECONDARY_BASE400, '#FFFFFF', 70],
        'secondary-408': [specials.SECONDARY_BASE400, '#FFFFFF', 80],
        'secondary-409': [specials.SECONDARY_BASE400, '#FFFFFF', 90],
        primary: [specials.COLOR, '#FFFFFF', 100], // site color
        secondary: [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        headline: [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        'headline-1': [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        'headline-2': [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        'headline-3': [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        'headline-4': [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        'headline-5': [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        text: '#222222',
        footer: ['#000000', '#FFFFFF', 50],
        'cw-body-background': [specials.COLOR, '#FFFFFF', 10],
        red: '#976464',
        green: '#349044',
        wrong: '#96060B',
        'depend-on-brightness': [specials.COLOR, '#FFFFFF', specials.BRIGHTNESS],
        'red-1': '#5a0303',
        'red-2': '#96060b',
        'red-3': '#ca8181',
        'red-4': '#e9cccc',
        'yellow-1': '#9F5F00',
        'yellow-2': '#FF9800',
        'yellow-3': '#FFB74D',
        'yellow-4': '#FFF3E0',
        'green-1': '#074709',
        'green-2': '#0e7710',
        'green-3': '#85ba87',
        'green-4': '#cde3ce',
    },
    1: {
        '000': ['#000000', '#FFFFFF', 100],
        '001': ['#000000', '#FFFFFF', 97],
        '002': ['#000000', '#FFFFFF', 90],
        '003': ['#000000', '#FFFFFF', 75],
        '004': ['#000000', '#FFFFFF', 60],
        '005': ['#000000', '#FFFFFF', 50],
        '006': ['#000000', '#FFFFFF', 40],
        '007': ['#000000', '#FFFFFF', 25],
        '008': ['#000000', '#FFFFFF', 10],
        '009': ['#000000', '#FFFFFF', 0],
        100: [specials.COLOR, '#2F2F2F', 20],
        101: [specials.COLOR, '#2F2F2F', 20],
        102: [specials.COLOR, '#2F2F2F', 30],
        103: [specials.COLOR, '#2F2F2F', 40],
        104: [specials.COLOR, '#2F2F2F', 50],
        105: [specials.COLOR, '#2F2F2F', 60],
        106: [specials.COLOR, '#2F2F2F', 70],
        107: [specials.COLOR, '#2F2F2F', 80],
        108: [specials.COLOR, '#2F2F2F', 90],
        109: [specials.COLOR, '#2F2F2F', 100],
        200: [specials.COLOR, '#777777', 0],
        201: [specials.COLOR, '#777777', 10],
        202: [specials.COLOR, '#777777', 20],
        203: [specials.COLOR, '#777777', 30],
        204: [specials.COLOR, '#777777', 40],
        205: [specials.COLOR, '#777777', 50],
        206: [specials.COLOR, '#777777', 60],
        207: [specials.COLOR, '#777777', 70],
        208: [specials.COLOR, '#777777', 80],
        209: [specials.COLOR, '#777777', 90],
        300: [specials.COLOR, '#242424', 90],
        301: [specials.COLOR, '#242424', 80],
        302: [specials.COLOR, '#242424', 70],
        303: [specials.COLOR, '#242424', 60],
        304: [specials.COLOR, '#242424', 50],
        305: [specials.COLOR, '#242424', 40],
        306: [specials.COLOR, '#242424', 30],
        307: [specials.COLOR, '#242424', 20],
        308: [specials.COLOR, '#242424', 10],
        309: [specials.COLOR, '#242424', 0],
        400: [specials.BASE400, specials.ACCENT400, 20],
        401: [specials.BASE400, specials.ACCENT400, 20],
        402: [specials.BASE400, specials.ACCENT400, 30],
        403: [specials.BASE400, specials.ACCENT400, 40],
        404: [specials.BASE400, specials.ACCENT400, 50],
        405: [specials.BASE400, specials.ACCENT400, 60],
        406: [specials.BASE400, specials.ACCENT400, 70],
        407: [specials.BASE400, specials.ACCENT400, 80],
        408: [specials.BASE400, specials.ACCENT400, 90],
        409: [specials.BASE400, specials.ACCENT400, 100],
        'secondary-100': [specials.SECONDARY_COLOR, '#2F2F2F', 20],
        'secondary-101': [specials.SECONDARY_COLOR, '#2F2F2F', 20],
        'secondary-102': [specials.SECONDARY_COLOR, '#2F2F2F', 30],
        'secondary-103': [specials.SECONDARY_COLOR, '#2F2F2F', 40],
        'secondary-104': [specials.SECONDARY_COLOR, '#2F2F2F', 50],
        'secondary-105': [specials.SECONDARY_COLOR, '#2F2F2F', 60],
        'secondary-106': [specials.SECONDARY_COLOR, '#2F2F2F', 70],
        'secondary-107': [specials.SECONDARY_COLOR, '#2F2F2F', 80],
        'secondary-108': [specials.SECONDARY_COLOR, '#2F2F2F', 90],
        'secondary-109': [specials.SECONDARY_COLOR, '#2F2F2F', 100],
        'secondary-200': [specials.SECONDARY_COLOR, '#777777', 0],
        'secondary-201': [specials.SECONDARY_COLOR, '#777777', 10],
        'secondary-202': [specials.SECONDARY_COLOR, '#777777', 20],
        'secondary-203': [specials.SECONDARY_COLOR, '#777777', 30],
        'secondary-204': [specials.SECONDARY_COLOR, '#777777', 40],
        'secondary-205': [specials.SECONDARY_COLOR, '#777777', 50],
        'secondary-206': [specials.SECONDARY_COLOR, '#777777', 60],
        'secondary-207': [specials.SECONDARY_COLOR, '#777777', 70],
        'secondary-208': [specials.SECONDARY_COLOR, '#777777', 80],
        'secondary-209': [specials.SECONDARY_COLOR, '#777777', 90],
        'secondary-300': [specials.SECONDARY_COLOR, '#242424', 90],
        'secondary-301': [specials.SECONDARY_COLOR, '#242424', 80],
        'secondary-302': [specials.SECONDARY_COLOR, '#242424', 70],
        'secondary-303': [specials.SECONDARY_COLOR, '#242424', 60],
        'secondary-304': [specials.SECONDARY_COLOR, '#242424', 50],
        'secondary-305': [specials.SECONDARY_COLOR, '#242424', 40],
        'secondary-306': [specials.SECONDARY_COLOR, '#242424', 30],
        'secondary-307': [specials.SECONDARY_COLOR, '#242424', 20],
        'secondary-308': [specials.SECONDARY_COLOR, '#242424', 10],
        'secondary-309': [specials.SECONDARY_COLOR, '#242424', 0],
        'secondary-400': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 20],
        'secondary-401': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 20],
        'secondary-402': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 30],
        'secondary-403': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 40],
        'secondary-404': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 50],
        'secondary-405': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 60],
        'secondary-406': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 70],
        'secondary-407': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 80],
        'secondary-408': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 90],
        'secondary-409': [specials.SECONDARY_BASE400, specials.SECONDARY_ACCENT400, 100],
        primary: [specials.COLOR, '#FFFFFF', 100], // site color
        secondary: [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        headline: '#FFFFFF',
        'headline-1': '#FFFFFF',
        'headline-2': '#FFFFFF',
        'headline-3': '#FFFFFF',
        'headline-4': '#FFFFFF',
        'headline-5': '#FFFFFF',
        text: '#FFFFFF',
        footer: ['#000000', '#FFFFFF', 50],
        'cw-body-background': [specials.COLOR, '#222222', 10],
        red: '#723F3F',
        green: '#198B2C',
        wrong: '#CA8181',
        'depend-on-brightness': [specials.COLOR, '#FFFFFF', specials.NEW_BRIGHTNESS],
        'red-1': '#5a0303',
        'red-2': '#96060b',
        'red-3': '#ca8181',
        'red-4': '#e9cccc',
        'yellow-1': '#9F5F00',
        'yellow-2': '#FF9800',
        'yellow-3': '#FFB74D',
        'yellow-4': '#FFF3E0',
        'green-1': '#074709',
        'green-2': '#0e7710',
        'green-3': '#85ba87',
        'green-4': '#cde3ce',
    },
    2: {
        '000': ['#000000', '#FFFFFF', 0],
        '001': ['#000000', '#FFFFFF', 3],
        '002': ['#000000', '#FFFFFF', 10],
        '003': ['#000000', '#FFFFFF', 25],
        '004': ['#000000', '#FFFFFF', 40],
        '005': ['#000000', '#FFFFFF', 50],
        '006': ['#000000', '#FFFFFF', 60],
        '007': ['#000000', '#FFFFFF', 75],
        '008': ['#000000', '#FFFFFF', 90],
        '009': ['#000000', '#FFFFFF', 100],
        100: [specials.COLOR, '#FFFFFF', 10],
        101: [specials.COLOR, '#FFFFFF', 10],
        102: [specials.COLOR, '#FFFFFF', 20],
        103: [specials.COLOR, '#FFFFFF', 30],
        104: [specials.COLOR, '#FFFFFF', 40],
        105: [specials.COLOR, '#FFFFFF', 50],
        106: [specials.COLOR, '#FFFFFF', 60],
        107: [specials.COLOR, '#FFFFFF', 70],
        108: [specials.COLOR, '#FFFFFF', 80],
        109: [specials.COLOR, '#FFFFFF', 90],
        200: [specials.COLOR, '#E4E4E4', 0],
        201: [specials.COLOR, '#E4E4E4', 10],
        202: [specials.COLOR, '#E4E4E4', 20],
        203: [specials.COLOR, '#E4E4E4', 30],
        204: [specials.COLOR, '#E4E4E4', 40],
        205: [specials.COLOR, '#E4E4E4', 50],
        206: [specials.COLOR, '#E4E4E4', 60],
        207: [specials.COLOR, '#E4E4E4', 70],
        208: [specials.COLOR, '#E4E4E4', 80],
        209: [specials.COLOR, '#E4E4E4', 90],
        300: [specials.COLOR, '#242424', 0],
        301: [specials.COLOR, '#242424', 10],
        302: [specials.COLOR, '#242424', 20],
        303: [specials.COLOR, '#242424', 30],
        304: [specials.COLOR, '#242424', 40],
        305: [specials.COLOR, '#242424', 50],
        306: [specials.COLOR, '#242424', 60],
        307: [specials.COLOR, '#242424', 70],
        308: [specials.COLOR, '#242424', 80],
        309: [specials.COLOR, '#242424', 90],
        400: [specials.BASE400, '#FFFFFF', 10],
        401: [specials.BASE400, '#FFFFFF', 10],
        402: [specials.BASE400, '#FFFFFF', 20],
        403: [specials.BASE400, '#FFFFFF', 30],
        404: [specials.BASE400, '#FFFFFF', 40],
        405: [specials.BASE400, '#FFFFFF', 50],
        406: [specials.BASE400, '#FFFFFF', 60],
        407: [specials.BASE400, '#FFFFFF', 70],
        408: [specials.BASE400, '#FFFFFF', 80],
        409: [specials.BASE400, '#FFFFFF', 90],
        'secondary-100': [specials.SECONDARY_COLOR, '#FFFFFF', 10],
        'secondary-101': [specials.SECONDARY_COLOR, '#FFFFFF', 10],
        'secondary-102': [specials.SECONDARY_COLOR, '#FFFFFF', 20],
        'secondary-103': [specials.SECONDARY_COLOR, '#FFFFFF', 30],
        'secondary-104': [specials.SECONDARY_COLOR, '#FFFFFF', 40],
        'secondary-105': [specials.SECONDARY_COLOR, '#FFFFFF', 50],
        'secondary-106': [specials.SECONDARY_COLOR, '#FFFFFF', 60],
        'secondary-107': [specials.SECONDARY_COLOR, '#FFFFFF', 70],
        'secondary-108': [specials.SECONDARY_COLOR, '#FFFFFF', 80],
        'secondary-109': [specials.SECONDARY_COLOR, '#FFFFFF', 90],
        'secondary-200': [specials.SECONDARY_COLOR, '#E4E4E4', 0],
        'secondary-201': [specials.SECONDARY_COLOR, '#E4E4E4', 10],
        'secondary-202': [specials.SECONDARY_COLOR, '#E4E4E4', 20],
        'secondary-203': [specials.SECONDARY_COLOR, '#E4E4E4', 30],
        'secondary-204': [specials.SECONDARY_COLOR, '#E4E4E4', 40],
        'secondary-205': [specials.SECONDARY_COLOR, '#E4E4E4', 50],
        'secondary-206': [specials.SECONDARY_COLOR, '#E4E4E4', 60],
        'secondary-207': [specials.SECONDARY_COLOR, '#E4E4E4', 70],
        'secondary-208': [specials.SECONDARY_COLOR, '#E4E4E4', 80],
        'secondary-209': [specials.SECONDARY_COLOR, '#E4E4E4', 90],
        'secondary-300': [specials.SECONDARY_COLOR, '#242424', 0],
        'secondary-301': [specials.SECONDARY_COLOR, '#242424', 10],
        'secondary-302': [specials.SECONDARY_COLOR, '#242424', 20],
        'secondary-303': [specials.SECONDARY_COLOR, '#242424', 30],
        'secondary-304': [specials.SECONDARY_COLOR, '#242424', 40],
        'secondary-305': [specials.SECONDARY_COLOR, '#242424', 50],
        'secondary-306': [specials.SECONDARY_COLOR, '#242424', 60],
        'secondary-307': [specials.SECONDARY_COLOR, '#242424', 70],
        'secondary-308': [specials.SECONDARY_COLOR, '#242424', 80],
        'secondary-309': [specials.SECONDARY_COLOR, '#242424', 90],
        'secondary-400': [specials.SECONDARY_BASE400, '#FFFFFF', 10],
        'secondary-401': [specials.SECONDARY_BASE400, '#FFFFFF', 10],
        'secondary-402': [specials.SECONDARY_BASE400, '#FFFFFF', 20],
        'secondary-403': [specials.SECONDARY_BASE400, '#FFFFFF', 30],
        'secondary-404': [specials.SECONDARY_BASE400, '#FFFFFF', 40],
        'secondary-405': [specials.SECONDARY_BASE400, '#FFFFFF', 50],
        'secondary-406': [specials.SECONDARY_BASE400, '#FFFFFF', 60],
        'secondary-407': [specials.SECONDARY_BASE400, '#FFFFFF', 70],
        'secondary-408': [specials.SECONDARY_BASE400, '#FFFFFF', 80],
        'secondary-409': [specials.SECONDARY_BASE400, '#FFFFFF', 90],
        primary: [specials.COLOR, '#FFFFFF', 100], // site color
        secondary: [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        headline: [specials.SECONDARY_COLOR, '#FFFFFF', 100], // secondary color
        'headline-1': [specials.SECONDARY_COLOR, '#FFFFFF', 100],
        'headline-2': [specials.SECONDARY_COLOR, '#FFFFFF', 100],
        'headline-3': [specials.SECONDARY_COLOR, '#FFFFFF', 100],
        'headline-4': [specials.SECONDARY_COLOR, '#FFFFFF', 100],
        'headline-5': [specials.SECONDARY_COLOR, '#FFFFFF', 100],
        text: '#222222',
        footer: ['#000000', '#FFFFFF', 50],
        'cw-body-background': '#FFFFFF',
        red: '#976464',
        green: '#349044',
        wrong: '#96060B',
        'depend-on-brightness': [specials.COLOR, '#FFFFFF', specials.BRIGHTNESS],
        'red-1': '#5a0303',
        'red-2': '#96060b',
        'red-3': '#ca8181',
        'red-4': '#e9cccc',
        'yellow-1': '#9F5F00',
        'yellow-2': '#FF9800',
        'yellow-3': '#FFB74D',
        'yellow-4': '#FFF3E0',
        'green-1': '#074709',
        'green-2': '#0e7710',
        'green-3': '#85ba87',
        'green-4': '#cde3ce',
    },
};

export { colorPalette, specials };
